export const ImportChatUtil = {
    getAllUniqueForAColumn : (data,target) => {
        const inboundSet = new Set();
        // Loop thorugh this inbound column to figure out how many values are actually present for this column
        for(let k = 0; k < data[target].length; k++){
            inboundSet.add(data[target][k]);
        }
        return inboundSet;
    }
}